import React from "react";

const ListDetailsCerita = () => {
  return (
    <section className="ceritaDetails-container">
      <p className="ceritaDetailsTitle">Cerita UMKM</p>

      <div className="testimony-row">
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Kenny Melvern</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Matthew Thomas</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Rayhan Fahlevy</p>
        </div>
      </div>

      <div className="testimony-row">
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Kenny Melvern</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Matthew Thomas</p>
        </div>
        <div className="testimony-card">
          <div className="testimony-column">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Corrupti, facilis error. Soluta, unde, officiis laborum ipsam
              molestias possimus eum numquam aperiam exercitationem repudiandae
              harum atque, laboriosam reprehenderit odit illo asperiores neque
              dignissimos nesciunt consequuntur sequi beatae nisi. Ratione, quis
              accusantium!
            </p>
            <p className="testimony-readMore">Read more</p>
          </div>
          <p className="testimony-name">Rayhan Fahlevy</p>
        </div>
      </div>
    </section>
  );
};

export default ListDetailsCerita;
